// extracted by mini-css-extract-plugin
export default {"footerContent":"FooterContent_footerContent__sp+gX","footerColumn":"FooterContent_footerColumn__JmcBH","contactLink":"FooterContent_contactLink__ZSvF7"};